import PropTypes from 'prop-types';

const pluginSummaryShape = PropTypes.shape({
  id: PropTypes.string,
  subscriptionId: PropTypes.string,
  name: PropTypes.string,
  creatorId: PropTypes.string,
  type: PropTypes.string,
  latestVersion: PropTypes.string,
  publishMode: PropTypes.string,
});

export default pluginSummaryShape;
